import { createRouter, createWebHistory, RouteLocationNormalized, RouteLocationNormalizedGeneric } from 'vue-router';
import privateRoutes from './privateRoutes';
import publicRoutes from './publicRoutes';
import { useAuthStore } from '@/stores';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/:pathMatch(.*)*',
            name: 'errors.404',
            component: () => import('@/views/pages/auth/PageNotFound.vue'),
        },
        publicRoutes,
        privateRoutes
    ]
});

function generate404(route: RouteLocationNormalized) {
    return {
        name: 'errors.404',
        params: { pathMatch: route.path.substring(1).split('/') },
        query: route.query,
        hash: route.hash,
    };
}

export function abortNotFound(route: RouteLocationNormalized) {
    router.push(generate404(route));
}

router.beforeEach(async (to) => {
    const store = useAuthStore();

    async function resolveNext(target: RouteLocationNormalizedGeneric) {
        if (!store.loaded) {
            await new Promise((res) => setTimeout(res, 200));
            return resolveNext(target);
        }

        if (to.meta.auth && !store.user.id) {
            return { name: 'login' };
        }

        if (to.meta.hybrid) {
            return true;
        }

        if (to.meta.guest && store.user.id) {
            return { name: 'dashboard' };
        }

        if (!to.meta.can) {
            return true;
        }

        const mod = to.meta.can as Record<string, string>;
        let action = mod.action;

        if (mod.action === 'form') {
            action = to.params.ulid ? 'edit' : 'create';
        }
        return store.can(`${action}.${mod.module}`) ? true : abortNotFound(to);
    }

    return resolveNext(to);
});